<section class="toolbar">
	<lvr-database-column-selector
		[options]="columnOptions()"
		[selectedColumnIds]="selectedColumnIds()"
		[applying]="columnSelectorLocked()"
		(applySelection)="applyColumns($event)"
	></lvr-database-column-selector>
	<lvr-button
		variant="primary"
		[label]="'database_view.institutions.toolbar.reset' | transloco"
		[type]="'button'"
		[disabled]="controlsLocked()"
		(clicked)="resetAll()"
		icon="filter_alt_off"
	></lvr-button>
	<lvr-button
		variant="primary"
		[label]="'base.button.export' | transloco"
		[ariaLabel]="'base.button.export_csv' | transloco"
		[loading]="exporting()"
		[disabled]="!canExport()"
		[type]="'button'"
		(clicked)="export()"
		icon="ios_share"
	></lvr-button>
</section>

@if (isPageLoading()) {
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="table-wrap">
	<table
		mat-table
		[dataSource]="pageRows()"
		[style.--database-column-count]="displayedColumns().length"
		class="mat-elevation-z0"
	>
		@for (column of columns; track column.key) {
			<ng-container [matColumnDef]="column.key">
				<th mat-header-cell *matHeaderCellDef>
					<div class="th-inline">
						<span class="th-label" [matTooltip]="column.labelKey | transloco">{{ column.labelKey | transloco }}</span>
						@if (column.sortField) {
							<button
								matIconButton
								class="btn-tertiary"
								[class.sort-active]="sortField() === column.sortField"
								[disabled]="controlsLocked()"
								[matMenuTriggerFor]="sortMenu"
								(click)="setActiveSortField(column.sortField)"
							>
								<mat-icon>{{ sortIcon(column.sortField) }}</mat-icon>
							</button>
						}
					</div>

					@if (column.searchKey) {
						<div class="th-filter-inline">
							@if (column.key === 'category') {
								<lvr-database-multi-select-filter
									#filterPanel
									[options]="filterOptions(column.searchKey)"
									[selectedValues]="filterValues()[column.searchKey]"
									[applying]="controlsLocked()"
									[disabled]="isFilterUnavailable(column.searchKey)"
									(selectionApplied)="applyMultiFilterSelection(column.searchKey, $event, filterPanel)"
									(panelClosed)="onMultiFilterPanelClosed(column.searchKey)"
								></lvr-database-multi-select-filter>
							} @else {
								<input
									class="th-filter-input"
									(click)="$event.stopPropagation()"
									[value]="filterSearch()[column.searchKey]"
									[class.is-filtered]="!!filterSearch()[column.searchKey]"
									[disabled]="controlsLocked()"
									(input)="setFilterSearch(column.searchKey, $any($event.target).value)"
									[placeholder]="'database_view.filters.placeholder_type_to_filter' | transloco"
								/>
							}
						</div>
					} @else {
						<div class="th-filter-inline"></div>
					}
				</th>

				<td mat-cell *matCellDef="let row">
					@if (column.key === 'name') {
						@if (hasBranchRoute(row)) {
							<a [routerLink]="branchRoute(row)" class="cell-link" [matTooltip]="row.name">{{ row.name }}</a>
						} @else {
							<span class="cell-text" [matTooltip]="row.name">{{ row.name }}</span>
						}
					} @else if (column.key === 'mainInstitution') {
						@if (hasMainInstitutionRoute(row)) {
							<a [routerLink]="mainInstitutionRoute(row)" class="cell-link" [matTooltip]="row.mainInstitution">{{
								row.mainInstitution
							}}</a>
						} @else {
							<span class="cell-text" [matTooltip]="row.mainInstitution">{{ row.mainInstitution }}</span>
						}
					} @else {
						<span class="cell-text" [matTooltip]="getCellValue(row, column.key)">{{
							getCellValue(row, column.key)
						}}</span>
					}
				</td>
			</ng-container>
		}

		<tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
		<tr class="mat-row" *matNoDataRow>
			<td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns().length">
				{{ 'database_view.institutions.no_data' | transloco }}
			</td>
		</tr>
	</table>
</div>

<div class="table-footer">
	<span class="total-results">{{ 'database_view.total_results' | transloco: { count: totalItems() } }}</span>
	<lvr-paginator
		[length]="totalItems()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[showFirstLastButtons]="true"
		[disabled]="controlsLocked()"
		preferenceKey="database-institutions-list"
		(page)="handlePageEvent($event)"
	></lvr-paginator>
</div>

<mat-menu #sortMenu="matMenu" class="sort-menu">
	<button
		mat-menu-item
		class="sort-menu-item"
		[disabled]="controlsLocked()"
		(click)="setSort(activeSortField(), 'asc')"
	>
		<span class="sort-menu-label">{{ sortLabel('asc') | transloco }}</span>
		<mat-icon class="sort-check" [class.is-hidden]="!isSortOptionActive(activeSortField(), 'asc')">check</mat-icon>
	</button>
	<button
		mat-menu-item
		class="sort-menu-item"
		[disabled]="controlsLocked()"
		(click)="setSort(activeSortField(), 'desc')"
	>
		<span class="sort-menu-label">{{ sortLabel('desc') | transloco }}</span>
		<mat-icon class="sort-check" [class.is-hidden]="!isSortOptionActive(activeSortField(), 'desc')">check</mat-icon>
	</button>
</mat-menu>
